import React from "react";
import { READING_ACTIONS } from "../../config/readingStates";
import "./reading.css";

export default function ReadingActionBar({ onAction, disabled = false, compact = false }) {
  const fire = (actionId, e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (disabled || !onAction) return;
    onAction(actionId);
  };

  return (
    <div className={`reading-action-bar${compact ? " reading-action-bar--compact" : ""}`}>
      {READING_ACTIONS.map((a) => (
        <button
          key={a.id}
          type="button"
          className={`reading-action-btn reading-action-btn--${a.id}`}
          disabled={disabled || !onAction}
          onClick={(e) => fire(a.id, e)}
          onPointerUp={(e) => e.stopPropagation()}
          title={a.label}
        >
          <span className="reading-action-btn__emoji" aria-hidden>{a.emoji}</span>
          {!compact && <span className="reading-action-btn__label">{a.label}</span>}
        </button>
      ))}
    </div>
  );
}
